module.exports = __webpack_public_path__ + "za.4b07683a.svg";